import { render } from "./admin-menu-edit.vue?vue&type=template&id=e31b1946&scoped=true"
import script from "./admin-menu-edit.vue?vue&type=script&lang=js"
export * from "./admin-menu-edit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31b1946"]])

export default __exports__